<script>
export default {
  props: {
    name: "",
    selected: false
  },

  data () {
    return {
      isActive: false
    }
  },

  computed: {
    href () {
      return '#' + this.name.toLowerCase().replace(/ /g, '-');
    }
  },

  mounted () {
    this.isActive = this.selected;
  }
}
</script>

<template lang="html">
  <div v-show="isActive" class="Tab">
    <slot></slot>
  </div>
</template>



// WEBPACK FOOTER //
// tab.vue?a2df915a